import { z } from "zod";

export const LoopWebhookRequestPathParamsSchema = z.object({
  shopId: z.string(),
});

export type LoopWebhookRequestPathParamsType = z.infer<
  typeof LoopWebhookRequestPathParamsSchema
>;
